<template>
  <section
    class="search-helper-left-nav"
    v-if="navList.length"
  >
    <div
      class="search-helper-left-nav__item"
      @click="updateCurrentNav(iNav.nav)"
      v-for="(iNav, index) in navList"
      :class="{'isActive': currentNav === iNav.nav}"
      :key="iNav.nav"
    >
      <div
        class="search-helper-left-nav__mask--top"
        v-if="index === 0"
      ></div>
      <div
        class="search-helper-left-nav__mask--bottom"
        v-if="index === navList.length -1"
      ></div>
      <div class="search-helper-left-nav__icon--circle"></div>
      <div class="search-helper-left-nav__icon--arrow"></div>
      <!-- <a :href="iNav.nav">{{iNav.label}}</a> -->
      <a>{{iNav.label}}</a>
    </div>
  </section>
</template>

<script>
export default {
    props: {
        navList: {
            type: Array,
            required: true
        },
        currentNav: {
            type: String,
            required: true
        }
    },
    methods: {
        updateCurrentNav(newNav) {
            this.$emit('input', newNav);
            this.$emit('shift-nav-handler', newNav);
        }
    }
};
</script>

<style lang="scss">
$commonBoder: 2px solid rgba(238, 238, 238, 1);
$activeColor: #286212;
$maskColor: #fafbfc;
$fontColor: rgba(6, 22, 50, 1);
.search-helper-left-nav {
  position: relative;
  border-left: $commonBoder;
  width: 144px;
  display: inline-block;
  &__item {
    position: relative;
    padding: 2px 0 2px 12px;
    font-size: 12px;
    color: $fontColor;
    line-height: 16px;
    vertical-align: top;
    margin-bottom: 12px;
    // word-break: break-all;

    a {
      text-decoration: none;
      color: $fontColor;
    }
    &:not(.isActive):hover {
      cursor: pointer;
      a {
        color: $activeColor;
      }
    }
    &.isActive {
      a {
        color: $activeColor;
      }
    }
    &:last-child {
      margin-bottom: 0;
    }

    .search-helper-left-nav__icon--arrow {
      display: none;
    }
    &.isActive {
      .search-helper-left-nav__icon--circle {
        display: none;
      }
      .search-helper-left-nav__icon--arrow {
        display: inline-block;
      }
    }
  }
  &__icon {
    &--circle,
    &--arrow {
      z-index: 2;
    }
    &--circle {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      border: $commonBoder;
      position: absolute;
      left: -6px;
      top: 5px;
      background: #fff;
    }
    &--arrow {
      background: url('../src/arrow.png') no-repeat center;
      width: 10px;
      height: 8px;
      position: absolute;
      left: -5px;
      top: 5px;
    }
  }
  &__mask {
    &--top,
    &--bottom {
      z-index: 1;
    }
    &--top {
      position: absolute;
      top: 0;
      left: -3px;
      width: 4px;
      height: 8px;
      background: $maskColor;
    }
    &--bottom {
      position: absolute;
      bottom: 0;
      left: -3px;
      width: 4px;
      height: calc(100% - 10px);
      background: $maskColor;
    }
  }
}
</style>
